import React from 'react';
import styled from 'styled-components';

const StyledBtnText = styled.span`
  margin: 0 auto;
`;

export default class SendText extends React.Component {
  render() {
    return <StyledBtnText>Say hi!</StyledBtnText>;
  }
}



// WEBPACK FOOTER //
// ./src/components/SendText.js